import { LandingPage } from '../types'
import { AVA_FORM } from './avaForm'
import {
  AVA_TEMPLATE_KEY,
  AVA_TEMPLATE_VERSION,
  templateBlocks,
} from './landingTemplates'
import { DEFAULT_THANK_YOU } from './thankYou'

export { AVA_VIDEO_THUMBNAIL } from './landingTemplates'

/** Ids legibles para la plantilla estática de respaldo (no vive en Supabase). */
function staticIds(): () => string {
  let index = 0
  return () => `b_${(index += 1)}`
}

/**
 * Landing principal de Sistema AVA. Usa exactamente la misma plantilla
 * «Landing con vídeo y calendario» que reciben las empresas, para que lo que
 * se ve en la página pública sea lo que el constructor genera.
 */
export const AVA_LANDING: LandingPage = {
  id: 'landing_ava',
  organizationId: 'org_ava',
  formId: AVA_FORM.id,
  name: 'Landing principal Sistema AVA',
  slug: 'sistema-ava',
  status: 'publicada',
  views: 8421,
  createdAt: '2026-05-02T09:00:00.000Z',
  updatedAt: '2026-07-28T16:10:00.000Z',
  pageConfig: {
    theme: 'blanco_premium',
    primaryColor: '#3D8BFF',
    fontFamily: 'Inter',
    templateKey: AVA_TEMPLATE_KEY,
    templateVersion: AVA_TEMPLATE_VERSION,
    blocks: templateBlocks('caso_exito', staticIds()),
    // Misma configuración por defecto que reciben las empresas.
    thankYou: { ...DEFAULT_THANK_YOU },
  },
}
